<template>
   <div class="table-responsive mb-0">
      <table class="table table-centered table-nowrap text-center">
         <thead class="thead-light">
            <tr>
               <th>Año</th>
               <th>Ene.</th>
               <th>Feb.</th>
               <th>Mar.</th>
               <th>Abr.</th>
               <th>May.</th>
               <th>Jun.</th>
               <th>Jul.</th>
               <th>Ago.</th>
               <th>Sep.</th>
               <th>Oct.</th>
               <th>Nov.</th>
               <th>Dic.</th>
            </tr>
         </thead>
         <tbody>
            <tr>
              <th>{{ year }}</th>
            <td v-for="(venta, index) in ventasGlobales.actual" :key="index">{{ venta | currency }}</td>
            </tr>
            <tr>
               <th>{{ year - 1 }}</th>
               <td v-for="(venta, index) in ventasGlobales.anterior" :key="index">{{ venta | currency }}</td>
            </tr>
            <tr>
               <th>%</th>
               <td v-for="(venta, index) in ventasGlobales.diferencia" :key="index" :class="[{ 'text-danger': venta < 0 }, 'text-success']">{{ venta | currency }}</td>
            </tr>
         </tbody>
      </table>
   </div>
</template>

<script>
   export default {
      props: {
         ventas: {
            type: Array,
            default: function() {
            return [];
            }
         }
      },
      data() {
         return {
            showModal: false,
            ventasGlobales: {
               actual: {
                  'ene': 0,
                  'feb': 0,
                  'mar': 0,
                  'abr': 0,
                  'may': 0,
                  'jun': 0,
                  'jul': 0,
                  'ago': 0,
                  'sep': 0,
                  'oct': 0,
                  'nov': 0,
                  'dic': 0
               },
               anterior: {
                  'ene': 0,
                  'feb': 0,
                  'mar': 0,
                  'abr': 0,
                  'may': 0,
                  'jun': 0,
                  'jul': 0,
                  'ago': 0,
                  'sep': 0,
                  'oct': 0,
                  'nov': 0,
                  'dic': 0
               },
               diferencia: {
                  'ene': 0,
                  'feb': 0,
                  'mar': 0,
                  'abr': 0,
                  'may': 0,
                  'jun': 0,
                  'jul': 0,
                  'ago': 0,
                  'sep': 0,
                  'oct': 0,
                  'nov': 0,
                  'dic': 0
               }
            }
         }
      },
      computed: {
         year (){ 
            return new Date().getFullYear()
         }
      },
      mounted () {
         this.ventas.forEach(element => {
            this.ventasGlobales.actual['ene'] = this.ventasGlobales.actual['ene'] + parseFloat(element.act01)
            this.ventasGlobales.actual['mar'] = this.ventasGlobales.actual['mar'] + parseFloat(element.act03)
            this.ventasGlobales.actual['abr'] = this.ventasGlobales.actual['abr'] + parseFloat(element.act04)
            this.ventasGlobales.actual['feb'] = this.ventasGlobales.actual['feb'] + parseFloat(element.act02)
            this.ventasGlobales.actual['may'] = this.ventasGlobales.actual['may'] + parseFloat(element.act05)
            this.ventasGlobales.actual['jun'] = this.ventasGlobales.actual['jun'] + parseFloat(element.act06)
            this.ventasGlobales.actual['jul'] = this.ventasGlobales.actual['jul'] + parseFloat(element.act07)
            this.ventasGlobales.actual['ago'] = this.ventasGlobales.actual['ago'] + parseFloat(element.act08)
            this.ventasGlobales.actual['sep'] = this.ventasGlobales.actual['sep'] + parseFloat(element.act09)
            this.ventasGlobales.actual['oct'] = this.ventasGlobales.actual['oct'] + parseFloat(element.act10)
            this.ventasGlobales.actual['nov'] = this.ventasGlobales.actual['nov'] + parseFloat(element.act11)
            this.ventasGlobales.actual['dic'] = this.ventasGlobales.actual['dic'] + parseFloat(element.act12)

            this.ventasGlobales.anterior['ene'] = this.ventasGlobales.anterior['ene'] + parseFloat(element.ant01)
            this.ventasGlobales.anterior['mar'] = this.ventasGlobales.anterior['mar'] + parseFloat(element.ant03)
            this.ventasGlobales.anterior['abr'] = this.ventasGlobales.anterior['abr'] + parseFloat(element.ant04)
            this.ventasGlobales.anterior['feb'] = this.ventasGlobales.anterior['feb'] + parseFloat(element.ant02)
            this.ventasGlobales.anterior['may'] = this.ventasGlobales.anterior['may'] + parseFloat(element.ant05)
            this.ventasGlobales.anterior['jun'] = this.ventasGlobales.anterior['jun'] + parseFloat(element.ant06)
            this.ventasGlobales.anterior['jul'] = this.ventasGlobales.anterior['jul'] + parseFloat(element.ant07)
            this.ventasGlobales.anterior['ago'] = this.ventasGlobales.anterior['ago'] + parseFloat(element.ant08)
            this.ventasGlobales.anterior['sep'] = this.ventasGlobales.anterior['sep'] + parseFloat(element.ant09)
            this.ventasGlobales.anterior['oct'] = this.ventasGlobales.anterior['oct'] + parseFloat(element.ant10)
            this.ventasGlobales.anterior['nov'] = this.ventasGlobales.anterior['nov'] + parseFloat(element.ant11)
            this.ventasGlobales.anterior['dic'] = this.ventasGlobales.anterior['dic'] + parseFloat(element.ant12)
         });
         this.ventasGlobales.diferencia['ene'] = (this.ventasGlobales.actual['ene'] - this.ventasGlobales.anterior['ene']) * 100 / this.ventasGlobales.anterior['ene']
         this.ventasGlobales.diferencia['feb'] = (this.ventasGlobales.actual['feb'] - this.ventasGlobales.anterior['feb']) * 100 / this.ventasGlobales.anterior['feb']
         this.ventasGlobales.diferencia['mar'] = (this.ventasGlobales.actual['mar'] - this.ventasGlobales.anterior['mar']) * 100 / this.ventasGlobales.anterior['mar']
         this.ventasGlobales.diferencia['abr'] = (this.ventasGlobales.actual['abr'] - this.ventasGlobales.anterior['abr']) * 100 / this.ventasGlobales.anterior['abr']
         this.ventasGlobales.diferencia['may'] = (this.ventasGlobales.actual['may'] - this.ventasGlobales.anterior['may']) * 100 / this.ventasGlobales.anterior['may']
         this.ventasGlobales.diferencia['jun'] = (this.ventasGlobales.actual['jun'] - this.ventasGlobales.anterior['jun']) * 100 / this.ventasGlobales.anterior['jun']
         this.ventasGlobales.diferencia['jul'] = (this.ventasGlobales.actual['jul'] - this.ventasGlobales.anterior['jul']) * 100 / this.ventasGlobales.anterior['jul']
         this.ventasGlobales.diferencia['ago'] = (this.ventasGlobales.actual['ago'] - this.ventasGlobales.anterior['ago']) * 100 / this.ventasGlobales.anterior['ago']
         this.ventasGlobales.diferencia['sep'] = (this.ventasGlobales.actual['sep'] - this.ventasGlobales.anterior['sep']) * 100 / this.ventasGlobales.anterior['sep']
         this.ventasGlobales.diferencia['oct'] = (this.ventasGlobales.actual['oct'] - this.ventasGlobales.anterior['oct']) * 100 / this.ventasGlobales.anterior['oct']
         this.ventasGlobales.diferencia['nov'] = (this.ventasGlobales.actual['nov'] - this.ventasGlobales.anterior['nov']) * 100 / this.ventasGlobales.anterior['nov']
         this.ventasGlobales.diferencia['dic'] = (this.ventasGlobales.actual['dic'] - this.ventasGlobales.anterior['dic']) * 100 / this.ventasGlobales.anterior['dic']
      }
   };
</script>